import { statsBuffer } from '../stats/buffer.mjs';

function createRenderStep(runNextFrame, stepName) {
  /**
   * We create and reuse two queues, one to queue jobs for the current frame
   * and one for the next. We reuse to avoid triggering GC after x frames.
   */
  var thisFrame = new Set();
  var nextFrame = new Set();
  /**
   * Track whether we're currently processing jobs in this step. This way
   * we can decide whether to schedule new jobs for this frame or next.
   */

  var isProcessing = false;
  var flushNextFrame = false;
  /**
   * A set of processes which were marked keepAlive when scheduled.
   */

  var toKeepAlive = new WeakSet();
  var latestFrameData = {
    delta: 0.0,
    timestamp: 0.0,
    isProcessing: false
  };
  var numCalls = 0;

  function triggerCallback(callback) {
    if (toKeepAlive.has(callback)) {
      step.schedule(callback);
      runNextFrame();
    }

    numCalls++;
    callback(latestFrameData);
  }

  var step = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: function schedule(callback) {
      var keepAlive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var addToCurrentFrame = immediate && isProcessing;
      var queue = addToCurrentFrame ? thisFrame : nextFrame;
      if (keepAlive) toKeepAlive.add(callback);
      if (!queue.has(callback)) queue.add(callback);
      return callback;
    },

    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: function cancel(callback) {
      nextFrame.delete(callback);
      toKeepAlive.delete(callback);
    },

    /**
     * Execute all schedule callbacks.
     */
    process: function process(frameData) {
      latestFrameData = frameData;
      /**
       * If we're already processing we've probably been triggered by a flushSync
       * inside an existing process. Instead of executing, mark flushNextFrame
       * as true and ensure we flush the following frame at the end of this one.
       */

      if (isProcessing) {
        flushNextFrame = true;
        return;
      }

      isProcessing = true;
      var _ref = [nextFrame, thisFrame];
      thisFrame = _ref[0];
      nextFrame = _ref[1];
      // Execute this frame
      thisFrame.forEach(triggerCallback);
      /**
       * If we're recording stats then
       */

      if (stepName && statsBuffer.value) {
        statsBuffer.value.frameloop[stepName].push(numCalls);
      }

      numCalls = 0; // Clear the frame so no callbacks remain. This is to avoid
      // memory leaks should this render step not run for a while.

      thisFrame.clear();
      isProcessing = false;

      if (flushNextFrame) {
        flushNextFrame = false;
        step.process(frameData);
      }
    }
  };
  return step;
}

export { createRenderStep };